enum WorkItemModalActions {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  VIEW = 'VIEW',
  REACTIVATE = 'REACTIVATE',
}

export default WorkItemModalActions;
